import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, Outlet, useParams, useRouteLoaderData } from '@rocketlane/rocket-router';
import styled from 'styled-components';
import { AppShellProvider } from 'contexts/providers/app-shell';
import { ProjectResourceOrUndefined } from 'hooks/rbac/useWithAccess';
import { SwitchContentBasedOnAccess } from 'hooks/rbac/withAccess';
import { useIsBootSkeletonPresent } from 'utils/dismiss-boot-skeleton';
import { getProjectPlanUrl, getProjectTasksUrl } from 'utils/urls';
import { RouteIds } from './routes-paths';
/**
 * Keeps AppShellProvider mounted for both authenticated and auth routes
 * (/login, /logout, magic-link, CP embed, etc.) so useAppShellMode consumers
 * never throw outside the provider during shell teardown or onboarding.
 */ export const AppShellRoutesLayout = ()=>/*#__PURE__*/ _jsx(AppShellProvider, {
        children: /*#__PURE__*/ _jsx(Outlet, {})
    });
export const Fallback = ()=>{
    // eslint-disable-next-line @calm/react-intl/missing-formatted-message
    return /*#__PURE__*/ _jsx("p", {
        children: "Performing initial data load"
    });
};
/**
 * Renders auth routes above `#rl-boot-skeleton` (z-index 9999) without
 * dismissing it — but only while it is still up. A permanent z-index 10000
 * stacking context buries every body-portaled overlay (Select menus at 1060,
 * antd dropdowns at 1050) behind the page.
 */ const AuthRoutesLayer = styled.div`
  position: ${({ $aboveBootSkeleton })=>$aboveBootSkeleton ? 'relative' : 'static'};
  z-index: ${({ $aboveBootSkeleton })=>$aboveBootSkeleton ? '10000' : 'auto'};
  min-height: 100vh;
  min-height: 100dvh;
`;
export const NonProtectedRoutesLayout = ()=>{
    const isBootSkeletonPresent = useIsBootSkeletonPresent();
    return /*#__PURE__*/ _jsx(AuthRoutesLayer, {
        $aboveBootSkeleton: isBootSkeletonPresent,
        children: /*#__PURE__*/ _jsx(Outlet, {})
    });
};
export const ProjectDetailRouteNavigator = ()=>{
    const { projectId: _projectId } = useParams();
    const projectData = useRouteLoaderData(RouteIds.projectDetailRoute);
    const projectAsResource = ProjectResourceOrUndefined(projectData);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(SwitchContentBasedOnAccess, {
            rule: "PROJECT:READ",
            resourceData: projectAsResource,
            hasAccess: /*#__PURE__*/ _jsx(Navigate, {
                replace: true,
                to: getProjectPlanUrl([
                    'project_id',
                    Number(projectData === null || projectData === void 0 ? void 0 : projectData.projectId)
                ])
            }),
            doesNotHaveAccess: /*#__PURE__*/ _jsx(Navigate, {
                replace: true,
                to: getProjectTasksUrl([
                    'project_id',
                    Number(projectData === null || projectData === void 0 ? void 0 : projectData.projectId)
                ])
            })
        })
    });
};
export const DashboardWidgetWrapper = ()=>{
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Outlet, {})
    });
};
